import React, { useEffect } from 'react';
import { STATIC_FILE_URL, WEBSITE_URL } from '@/shared/constants';
import { logCommonView, logPageView } from '@/lib/service';

import { EventSource } from '@/shared/constants/event';
import Head from 'next/head';
import HomepageV4 from '@/components/Home/HomepageV4';
import { Layout } from '@/components/Common';
import { SEO_META } from '@/shared/seo';
import { SEO_META_PAGES } from '@/shared/types/seo';

const HOMEPAGE_TITLE = 'The private AI brain for fast growing brands';
const HOMEPAGE_DESCRIPTION =
  'Unify your data, workflows, and execution across marketing, sourcing, and operations. Access all the models in one place with flexible controls to build a system as unique as your brand.';
const HOMEPAGE_IMAGE = `${STATIC_FILE_URL}/8f83f11283ff5a8074adb986e14272f0.png`;

const Home = () => {
  useEffect(() => {
    logPageView({
      pageUrl: window.location.href || '',
      routeName: window.location.pathname,
      pageTitle: 'Pietra',
    });
    logCommonView(EventSource.HOMEPAGE, 'INDEX');
  }, []);

  return (
    <>
      <Head>
        <title key="title">{HOMEPAGE_TITLE}</title>
        <meta key="description" name="description" content={HOMEPAGE_DESCRIPTION} />
        <meta key="og:url" property="og:url" content={WEBSITE_URL} />
        <meta key="og:title" property="og:title" content={HOMEPAGE_TITLE} />
        <meta key="og:description" property="og:description" content={HOMEPAGE_DESCRIPTION} />
        <meta key="og:image" property="og:image" content={HOMEPAGE_IMAGE} />
        <meta key="twitter:domain" property="twitter:domain" content="pietrastudio.com" />
        <meta key="twitter:url" property="twitter:url" content={WEBSITE_URL} />
        <meta key="twitter:title" name="twitter:title" content={HOMEPAGE_TITLE} />
        <meta key="twitter:description" name="twitter:description" content={HOMEPAGE_DESCRIPTION} />
        <meta key="twitter:image" name="twitter:image" content={HOMEPAGE_IMAGE} />
      </Head>
      <HomepageV4 />
    </>
  );
};

Home.getLayout = (page: React.ReactElement) => {
  return <Layout structured={SEO_META[SEO_META_PAGES.HOME]?.jsonld()}>{page}</Layout>;
};

export default Home;
